import { DiscountService } from './discount.service';
import { FinaPrintService } from './fina-print.service';
import { PaymentMethodsService } from './paymentMethods.service';
import { UserAssociatedService } from './userAssociated.service';

export const services = [PaymentMethodsService, UserAssociatedService, DiscountService, FinaPrintService];

export * from './discount.service';
export * from './fina-print.service';
export * from './improve-fina-intent.service';
export * from './paymentMethods.service';
export * from './userAssociated.service';
